var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('landing-pages-list',{attrs:{"filters":_vm.filters,"hide-job-board":""}})}
var staticRenderFns = []

export { render, staticRenderFns }